module.exports = __webpack_public_path__ + "img/avatar_ico14.86a86760.jpg";